export default "__VITE_ASSET__wnHWivRB__";